/**
 * Units Mapping Services - Re-exports from Module
 * 
 * This file re-exports all units mapping types and hooks from the
 * centralized module at src/modules/channels.
 * 
 * @deprecated Import directly from '@modules/channels' for new code
 */

// Types - re-export from module
export type {
  ChannelName,
  UnitMappingStatus,
  ILinkedUnit,
  IMsoolUnit,
  IUnitSelection,
  IFilterState,
  IGetMsoolUnitsResponse,
  IMappingUnitRequestDto,
  IMapUnitsRequest,
  IMapUnitsResponse,
  IUnmapUnitRequestDto,
  IUnmapUnitsRequest,
  IUnmapUnitsResponse,
} from '../../modules/channels/types';

// Re-export ChannelType enum
export { ChannelType } from '../../modules/channels/types';

// Re-export IChannelUnit from the module's units-mapping types
export type { IChannelUnit } from '../../modules/channels/types/units-mapping.types';

// Hooks - re-export from module services
export { useGetMsoolUnits } from '../../modules/channels/services/mapping.service';
export { useMapUnits } from '../../modules/channels/services/mapping.service';
export { useUnmapUnits } from '../../modules/channels/services/mapping.service';

// IApiResponse - re-export for backward compatibility
export type { IApiResponse } from '../../modules/channels/types';
